import { ComputedSection, Totals } from './types';

export function computeTaxes(sections: ComputedSection[]): Totals {
  const taxable = sections.filter((s) => s.taxable).reduce((a, s) => a + s.total, 0);
  const nonTaxable = sections.filter((s) => !s.taxable).reduce((a, s) => a + s.total, 0);
  const tps = taxable * 0.05;
  const tvq = taxable * 0.09975;
  const subtotal = taxable + nonTaxable;
  return { subtotal, taxable, nonTaxable, tps, tvq, grandTotal: subtotal + tps + tvq };
}
